export default __webpack_public_path__ + "static/media/aws.2c22650a.jpg";